const DATA_LAYER = 'dataLayer';
const VIRTUAL_FUNNEL_CLICK = 'VirtualFunnelClick';
class BalGoogleTagManager {
    isEnabled() {
        const win = window;
        return win && win[DATA_LAYER] != null && win.localStorage.getItem('ga_debug_mode') !== 'true';
    }
    load(settings) {
        if (!this.isEnabled()) {
            this.runGtmScript(settings.apiKey);
        }
    }
    /**
     * @deprecated this method should not be used
     * @param settings GTM settings for application
     */
    loadForce(settings) {
        this.runGtmScript(settings.apiKey);
    }
    sendClickEvent(label) {
        if (label) {
            this.googleAnalyticsSendEvent({
                event: VIRTUAL_FUNNEL_CLICK,
                VirtualClickCategory: VIRTUAL_FUNNEL_CLICK,
                VirtualClickAction: this.applicationName,
                VirtualClickLabel: label
            });
        }
    }
    ;
    sendCustomEvent(event) {
        if (event) {
            this.googleAnalyticsSendEvent(event);
        }
    }
    /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call */
    runGtmScript(apiKey) {
        const w = window;
        const d = document;
        const s = 'script';
        const l = DATA_LAYER;
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(), event: 'gtm.js'
        });
        const f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = '';
        j.async = true;
        j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + apiKey + dl;
        f.parentNode.insertBefore(j, f);
    }
    googleAnalyticsSendEvent(event) {
        if (window[DATA_LAYER]) {
            window[DATA_LAYER].push(event);
        }
    }
}

const GtmAction = {
    Click: "CLICK",
    Focus: "FOCUS",
    Load: "LOAD",
    Search: "SEARCH",
};

export { BalGoogleTagManager, GtmAction };
//# sourceMappingURL=index.esm.js.map
